module.exports = __webpack_public_path__ + "templates/cart-payment.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cart/templates/cart-payment.html
// module id = WeP3
// module chunks = 1